package com.neurobs.react

import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.web.html.{button, className, disabled, onClick}

object ButtonSize extends Enumeration {
	val Small, Medium = Value
}

@react object Button {
	case class Props
	(
		caption: String,
		disabled: Boolean = false,
		size: ButtonSize.Value = ButtonSize.Medium,
		onClick: () => Unit
	)

	val component = FunctionalComponent[Props] { props =>
		val cName = props.size match {
			case ButtonSize.Small => defaultButtonClass + " " + defaultButtonSmallClass
			case _ => defaultButtonClass
		}
		button(className := cName, disabled := props.disabled, onClick := props.onClick)(props.caption)
	}

	private val defaultButtonClass = "efactory-button"
	private val defaultButtonSmallClass = "efactory-button-small"
}
